import React, { useState } from "react";
import jsDig from "utils/jsDig";
import LiteMetricTable from "dashboards/lite/LiteMetricTable";
import LiteBuyBoxTable from "dashboards/lite/LiteBuyBoxTable";
import LiteLineChart from "dashboards/lite/LiteLineChart";
import LiteRefresh from "dashboards/lite/LiteRefresh";
import YearPicker from "dashboards/lite/YearPicker";
import ObjectivePicker from "dashboards/lite/ObjectivePicker";
import DashboardOptions from "dashboards/lite/DashboardOptions";
import { capitalize } from "lodash";
import LiteExportPDF from 'utils/LiteExportPDF';

export default function AmazonDashboard(props) {
  const metricTableDimensions = jsDig(["overall", "total", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "total", "spend"], props.table_data)) : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", "YTD", "Total"];
  const buyBoxTableDimensions = jsDig(["overall", "buy_box_data", "last_30"], props.table_data) ? Object.keys(jsDig(["overall", "buy_box_data", "last_30"], props.table_data)) : [];
  // Convert utc date to local time in this format 12:30 PM, 12/31/2021
  const lastDataPull = new Date(jsDig(["last_data_pull"], props)).toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
    month: "numeric",
    day: "numeric",
    year: "numeric",
  });

  // Read the 'year' query param if it exists
  const urlParams = new URLSearchParams(window.location.search);
  const queryYear = parseInt(urlParams.get("year"), 10);

  // If queryYear is not a valid number, use the current year, else use queryYear
  const thisYear = isNaN(queryYear) ? new Date().getFullYear() : queryYear;
  const lastYear = thisYear - 1;

  let mainIcon = require("images/lite/icons/amazon.svg");
  mainIcon = <div className="other-icon active dashboard-icon"><img className="dashboard-icon-2" src={`/datapulse${mainIcon}`} /></div>
  let disabledIcon = require("images/lite/icons/coming-soon.png");
  disabledIcon = <div className="coming-soon-icon"><img src={`/datapulse${disabledIcon}`} /></div>

  const [dashboardObjective, setDashboardObjective] = useState(props.client_account.dashboard_objective ? props.client_account.dashboard_objective : "sales");
  let revenueOrConversions = dashboardObjective == "sales" ? "revenue" : "conversions";
  let roasOrCpa = dashboardObjective == "sales" ? "roas" : "cpa";

  const dashboardType = "amazon"
  const [dashboardOptions, setDashboardOptions] = useState(props.client_account.dashboard_options ? props.client_account.dashboard_options : {});

  return (
    <>
      <div className="lite-dashboard amazon-dashboard">
        <div className="dashboard-header">
          <div className="dashboard-header-left">
            {mainIcon}
            <h1>Amazon Dashboard</h1>
          </div>
          <div className="dashboard-header-center">
          </div>
          <div className="dashboard-header-right flex-end">
            <div className="most-recent-refresh">
              <small id="most-recent-refresh">Last refresh: {props.last_data_pull ? lastDataPull : "Never"}</small>
            </div>
            <div className="objective-refresh-container">
              <YearPicker/>
              <ObjectivePicker setDashboardObjective={setDashboardObjective} dashboardObjective={dashboardObjective} />
              {props.user_is_employee && (
                <LiteRefresh refreshPreference={props.default_refresh_preference} currentDashboard={"amazon"} accountId={props.client_account.id} alreadyPulling={props.current_data_pulls} />
              )}
              <DashboardOptions dashboardOptions={dashboardOptions} setDashboardOptions={setDashboardOptions} dashboardType={dashboardType} accountId={props.client_account.id} />
              <LiteExportPDF companyName={props.company_name} dashName="Amazon" />
            </div>
          </div>
        </div>
        <div className="dashboard-body">
          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["amazon_seller", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["amazon_seller", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["amazon_seller", "total", revenueOrConversions, "data"], props.chart_data)}
                chartName={`Total ${capitalize(revenueOrConversions)} L60D`}
                metric={revenueOrConversions}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", roasOrCpa, "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", roasOrCpa, "labels"], props.chart_data)}
                data={jsDig(["overall", "total", roasOrCpa, "data"], props.chart_data)}
                chartName={`Total ${roasOrCpa.toUpperCase()} L60D`}
                metric={roasOrCpa}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["amazon_ads", "total", "spend", "dataset_names"], props.chart_data)}
                labels={jsDig(["amazon_ads", "total", "spend", "labels"], props.chart_data)}
                data={jsDig(["amazon_ads", "total", "spend", "data"], props.chart_data)}
                chartName="Ad Spend L60D"
                metric="spend"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["amazon_ads", "total", revenueOrConversions, "dataset_names"], props.chart_data)}
                labels={jsDig(["amazon_ads", "total", revenueOrConversions, "labels"], props.chart_data)}
                data={jsDig(["amazon_ads", "total", revenueOrConversions, "data"], props.chart_data)}
                chartName={`Ad ${capitalize(revenueOrConversions)} L60D`}
                metric={revenueOrConversions}
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["amazon_seller", "total", "conversion_rate", "dataset_names"], props.chart_data)}
                labels={jsDig(["amazon_seller", "total", "conversion_rate", "labels"], props.chart_data)}
                data={jsDig(["amazon_seller", "total", "conversion_rate", "data"], props.chart_data)}
                chartName="Conversion Rate L60D"
                metric="conversion_rate"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "total"], props.table_data)}
                tableName="Total Amazon"
                dimensions={metricTableDimensions}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["amazon_ads", "total", "clicks", "dataset_names"], props.chart_data)}
                labels={jsDig(["amazon_ads", "total", "clicks", "labels"], props.chart_data)}
                data={jsDig(["amazon_ads", "total", "clicks", "data"], props.chart_data)}
                chartName="Paid Sessions L60D"
                metric="clicks"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>
          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteBuyBoxTable
                subHeaderOrder={["revenue", "buy_box_percentage"]}
                headerOrder={["yesterday", "last_30"]}
                data={jsDig(["overall", "buy_box_data"], props.table_data)}
                tableName="Products Losing Buy Box (Under 90%)"
                dimensions={buyBoxTableDimensions}
                buyBox={true}
              />
            </div>
            <div className="lite-metric-chart">
              <LiteLineChart 
                datasetNames={jsDig(["overall", "total", "organic_sessions", "dataset_names"], props.chart_data)}
                labels={jsDig(["overall", "total", "organic_sessions", "labels"], props.chart_data)}
                data={jsDig(["overall", "total", "organic_sessions", "data"], props.chart_data)}
                chartName="Organic Sessions L60D"
                metric="sessions"
                colorBlindAssist={props.color_blind_assist}
              />
            </div>
          </div>

          <div className="lite-dashboard-section">
            <div className="lite-metric-table">
              <LiteMetricTable
                headerOrder={["spend", revenueOrConversions, roasOrCpa]}
                subHeaderOrder={[lastYear, thisYear, "Y/Y"]}
                data={jsDig(["overall", "l60"], props.table_data)}
                tableName="Total Amazon - Daily L60D"
                dimensions={jsDig(["overall", "l60", "spend"], props.table_data) ? Object.keys(jsDig(["overall", "l60", "spend"], props.table_data)) : []}
                topSummaryRow={{dimension: "L7D >", data: jsDig(["overall", "l7"], props.table_data)}}
                collapsed={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
